import React, { useEffect, useState } from 'react';

import { Grid } from '@mui/material';

interface EnvJson {
  GIT_COMMIT: string;
  GIT_COMMIT_TIME: string;
  CI_PIPELINE_ID: string;
  CI_COMMIT_BRANCH: string;
}

export default function AdminPage() {
  const [appInformation, setAppInformation] = useState<EnvJson>({
    GIT_COMMIT: '',
    GIT_COMMIT_TIME: '',
    CI_PIPELINE_ID: '',
    CI_COMMIT_BRANCH: '',
  });
  function getAppBuildInformation(): Promise<EnvJson> {
    return fetch('/static/env.json')
      .then((response) => response.json())
      .then((responseJson) => responseJson)
      .catch((e) => {
        console.error(e);
      });
  }

  useEffect(() => {
    getAppBuildInformation().then((response) => {
      setAppInformation(response);
    });
  }, []);

  return (
    <Grid xs={12} container direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={5}>
      <Grid item>
        {appInformation.GIT_COMMIT && <div>GIT_COMMIT: {appInformation.GIT_COMMIT}</div>}
        {appInformation.GIT_COMMIT_TIME && <div>GIT_COMMIT_TIME: {appInformation.GIT_COMMIT_TIME}</div>}
        {appInformation.CI_PIPELINE_ID && <div>CI_PIPELINE_ID: {appInformation.CI_PIPELINE_ID}</div>}
        {appInformation.CI_COMMIT_BRANCH && <div>CI_COMMIT_BRANCH: {appInformation.CI_COMMIT_BRANCH}</div>}
        <div>REACT_APP_ENV: {process.env.REACT_APP_ENV}</div>
        <div>NODE_ENV: {process.env.NODE_ENV}</div>
      </Grid>
    </Grid>
  );
}
